module.exports = __webpack_public_path__ + "static/media/S-15.0f420f26.mp3";